module.exports = __webpack_public_path__ + "static/media/paysafe.fccf3a59.svg";